import { render, staticRenderFns } from "./taskToRevoke.vue?vue&type=template&id=5dc9b53b&scoped=true&"
import script from "./taskToRevoke.vue?vue&type=script&lang=js&"
export * from "./taskToRevoke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc9b53b",
  null
  
)

export default component.exports